import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './WingLoginModal.module.scss';
import { WING_TEST_ACCOUNT } from './constants';
import { setWingLocalLoggedIn } from './storage';

const WingLoginModal = ({ onClose, onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === WING_TEST_ACCOUNT.username && password === WING_TEST_ACCOUNT.password) {
      setWingLocalLoggedIn(true);
      setError('');
      onSuccess?.();
      return;
    }
    setError('Incorrect username or password');
  };

  const handleMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div className={s.mask} onClick={handleMaskClick}>
      <div className={s.panel}>
        <button type="button" className={s.close} onClick={onClose} aria-label="close" />
        <div className={s.title}>Wing Playground Login</div>
        {/* <div className={s.hint}>
          Test account: {WING_TEST_ACCOUNT.username} / {WING_TEST_ACCOUNT.password}
        </div> */}
        <form className={s.form} onSubmit={handleSubmit}>
          <label className={s.label}>
            Username
            <input
              className={s.input}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              placeholder="Enter username"
            />
          </label>
          <label className={s.label}>
            Password
            <input
              className={s.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="Enter password"
            />
          </label>
          {error ? <div className={s.error}>{error}</div> : null}
          <button type="submit" className={s.submit}>
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

WingLoginModal.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default WingLoginModal;
